import { SHELL_PENDING_SYNC_COUNT_CHANGED_EVENT } from '@core/domain/shellPendingSyncEvents.ts';
import type { ShellAuthApplicationPort } from '../../app-context/domain/ports/ShellAuthApplicationPort.ts';
import { resolveShellPermissions } from '../../app-context/domain/shellModulePermissions.ts';

/** Accepts the auth port (injectable). */
export async function fetchShellPermissionSet(auth: ShellAuthApplicationPort): Promise<ReadonlySet<string>> {
  try {
    if (!(await auth.isAuthenticated())) return new Set();
    return resolveShellPermissions(await auth.getCurrentUser());
  } catch {
    return new Set();
  }
}
/** On shell route change. */


export function onShellRouteChange(handler: () => void): () => void {
  const run = (): void => {
    setTimeout(handler, 0);
  };
  globalThis.addEventListener('navigate', run);
  globalThis.addEventListener('popstate', run);
  return () => {
    globalThis.removeEventListener('navigate', run);
    globalThis.removeEventListener('popstate', run);
  };
}

/** Re-read pending sync counts (e.g. nav badge) after save or sync. */
export function onShellPendingSyncCountChanged(handler: () => void): () => void {
  const run = (): void => {
    setTimeout(handler, 0);
  };
  globalThis.addEventListener(SHELL_PENDING_SYNC_COUNT_CHANGED_EVENT, run);
  return () => {
    globalThis.removeEventListener(SHELL_PENDING_SYNC_COUNT_CHANGED_EVENT, run);
  };
}
